module.exports = __webpack_public_path__ + "img/alert-error.8bc6b0f8.svg";